export default __webpack_public_path__ + "static/media/banner1.4eb22e6f.jpg";